/**
 * NOWROCKY - "POKAZ WIECEJ" zamiast paginacji.
 * Pelne uzasadnienie: docs/THEME_CHANGELOG.md, wpis v29.
 *
 * W skrocie: wbudowany infinite scroll Horizona doklada strony SAM
 * (IntersectionObserver na <span ref="viewMoreNext">, metody prywatne),
 * wiec nie da sie go przerobic na klikniecie. Zostawiamy normalna paginacje,
 * chowamy ja wizualnie (linki zostaja dla crawlera) i podkladamy guzik.
 */
(function () {
  'use strict';

  if (window.__nwrShowMore) return;
  window.__nwrShowMore = true;

  var TEKSTY = {
    pl: { wiecej: 'POKAŻ WIĘCEJ', laduje: 'ŁADUJĘ…', licznik: 'Pokazano {n}', blad: 'SPRÓBUJ PONOWNIE' },
    en: { wiecej: 'SHOW MORE', laduje: 'LOADING…', licznik: 'Showing {n}', blad: 'TRY AGAIN' },
    zh: { wiecej: '显示更多', laduje: '加载中…', licznik: '已显示 {n}', blad: '重试' }
  };

  function teksty() {
    var lang = (document.documentElement.getAttribute('lang') || 'pl').toLowerCase();
    if (lang.indexOf('zh') === 0) return TEKSTY.zh;
    if (lang.indexOf('en') === 0) return TEKSTY.en;
    return TEKSTY.pl;
  }

  /** Link „nastepna strona" siedzi w OSTATNIM <li> paginacji. Pierwszy to „poprzednia". */
  function nastepny(nav) {
    return nav.querySelector('.pagination__list > li:last-child a.pagination__link--arrow');
  }

  function ileKart(grid) {
    return grid.querySelectorAll(':scope > .product-grid__item').length;
  }

  /* Sama liczba zaladowanych kart, bez sumy calkowitej. Suma nie jest nigdzie
     w DOM-ie, a dokladanie jej przez atrybut w snippecie motywu to grzebanie
     w plikach Horizona dla kosmetyki — pasek filtrow i tak pokazuje ile jest. */
  function odswiezLicznik(licz, grid) {
    licz.textContent = teksty().licznik.replace('{n}', ileKart(grid));
  }

  function zbuduj(lista) {
    var nav = lista.querySelector('nav.pagination');
    var grid = lista.querySelector('ul.product-grid');
    if (!nav || !grid) return;
    if (nav.getAttribute('data-nwr-done') === '1') return;
    if (!nastepny(nav)) return; // jedna strona — nie ma czego dokladac
    nav.setAttribute('data-nwr-done', '1');
    nav.classList.add('nwr-pagination--schowana');

    var box = document.createElement('div');
    box.className = 'nwr-more';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nwr-more__btn';
    btn.textContent = teksty().wiecej;

    var licz = document.createElement('p');
    licz.className = 'nwr-more__count';

    box.appendChild(btn);
    box.appendChild(licz);
    nav.parentNode.insertBefore(box, nav);
    odswiezLicznik(licz, grid);

    var zajety = false;

    btn.addEventListener('click', function () {
      if (zajety) return;
      var link = nastepny(nav);
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;

      zajety = true;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = teksty().laduje;

      fetch(href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nowyGrid = doc.querySelector('ul.product-grid');
          if (!nowyGrid) throw new Error('brak siatki w odpowiedzi');

          var karty = nowyGrid.querySelectorAll(':scope > .product-grid__item');
          if (!karty.length) throw new Error('zero kart w odpowiedzi');

          var pierwsza = null;
          for (var i = 0; i < karty.length; i++) {
            var karta = document.importNode(karty[i], true);
            if (!pierwsza) pierwsza = karta;
            grid.appendChild(karta);
          }

          /* Nowa paginacja z pobranej strony podmienia stara — stad bierze sie
             adres kolejnej strony. Atrybuty naszego <nav> zostaja nietkniete. */
          var nowyNav = doc.querySelector('nav.pagination');
          if (nowyNav) {
            nav.innerHTML = nowyNav.innerHTML;
          }

          zajety = false;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');

          if (!nowyNav || !nastepny(nav)) {
            box.remove();
          } else {
            btn.textContent = teksty().wiecej;
            odswiezLicznik(licz, grid);
          }

          // czytnik ekranu ma wiedziec, ze cos doszlo
          if (pierwsza) pierwsza.setAttribute('tabindex', '-1');
        })
        .catch(function () {
          /* Siec padla — nie zostawiamy martwego guzika. Pierwszy klik po bledzie
             przenosi na normalna strone paginacji, czyli tam, gdzie i tak chcial trafic. */
          zajety = false;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = teksty().blad;
          btn.onclick = function () {
            window.location.href = href;
          };
        });
    });
  }

  function inicjuj() {
    var listy = document.querySelectorAll('results-list');
    for (var i = 0; i < listy.length; i++) zbuduj(listy[i]);
  }

  /* Po zmianie filtrow Shopify przerenderowuje sekcje w miejscu i nasz guzik znika
     razem ze stara trescia. Obserwujemy WRAPPER sekcji (on przezywa render). */
  var czeka = null;
  function obserwuj() {
    var listy = document.querySelectorAll('results-list');
    for (var i = 0; i < listy.length; i++) {
      var sekcja = listy[i].closest('[id^="shopify-section-"]');
      if (!sekcja || sekcja.getAttribute('data-nwr-obs') === '1') continue;
      sekcja.setAttribute('data-nwr-obs', '1');
      new MutationObserver(function () {
        clearTimeout(czeka);
        czeka = setTimeout(inicjuj, 120);
      }).observe(sekcja, { childList: true, subtree: true });
    }
  }

  function start() {
    inicjuj();
    obserwuj();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
